import React from "react";
import Box from "@mui/material/Box";
import { ProductCategoryInput } from "../../../../../../components/filters/ProductCategory/ProductCategoryInput";

interface ProductCategoriesFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export const ProductCategoriesFilter: React.FC<ProductCategoriesFilterProps> =
  React.memo(({ value, onChange }) => {
    return (
      <Box id="install-product-category-filter" sx={{ mb: 1 }}>
        <ProductCategoryInput
          selectedItems={value}
          onProductCategorySelect={onChange}
          id="install-product-category-input"
        />
      </Box>
    );
  });
